<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Meus espelhos de ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <th scope="col">Período</th>
                <th scope="col">Início Período</th>
                <th scope="col">Fim Período</th>
                <th scope="col">Jornada</th>
                <th scope="col">Feriados no Período</th>
                <th scope="col">Dias Úteis</th>
                <th scope="col">Total à Trabalhar</th>
                <th scope="col">Total Trabalhado</th>
                <th scope="col">Banco de Horas no Período</th>
                <th scope="col">Ações</th>
              </thead>
              <tbody>
                <tr v-for="mirror in mirrors" :key="mirror.id">
                  <td>
                    {{ mirror.period_f }}
                  </td>
                  <td>{{ mirror.start_period }}</td>
                  <td>{{ mirror.end_period }}</td>
                  <td>{{ mirror.journey ? mirror.journey.title : '-' }}</td>
                  <td>{{ mirror.holidays }}</td>
                  <td>{{ mirror.usefull_days }}</td>
                  <td>{{ mirror.total_working }}</td>
                  <td>{{ mirror.total_worked }}</td>
                  <td>{{ mirror.bank_of_hours }}</td>
                    <td>
                    <a
                      href="#"
                      @click.prevent="openMirror(mirror.id)"
                      class="btn btn-crud edit"
                      rel="noopener noreferrer"
                      ><i class="fas fa-download"></i
                    ></a>
                  </td>
                </tr>
                <tr>
                  <td v-if="mirrors.length == 0" colspan="10" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mirrors: [],
    };
  },
  computed: {},
  methods: {
    downloadMirror: function (id) {
      const base = this.$store.state.url || '';
      const normalized = base.endsWith('/') ? base : base + '/';
      return (
        normalized +
        "export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    openMirror: function (id) {
      const url = this.downloadMirror(id);
      const w = window.open('about:blank', '_blank');
      if (w) {
        try {
          w.opener = null;
          w.location.href = url;
        } catch (e) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    getEntity: function () {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "point-mirror/my";

      axios
        .post(api)
        .then((response) => {
          self.mirrors = response.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getEntity();
  },
};
</script>

<style>
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.mirror-table th,
.mirror-table td {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

@media (max-width: 900px) {
  .mirror-table th,
  .mirror-table td {
    font-size: 0.95rem;
    padding: 0.4rem;
  }
  .card-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 600px) {
  .mirror-table {
    font-size: 0.88rem;
  }
  .mirror-table th,
  .mirror-table td {
    padding: 0.3rem;
    font-size: 0.88rem;
  }
  .card-title {
    font-size: 1rem;
  }
}

@media (max-width: 500px) {
  .mirror-table {
    font-size: 0.8rem;
  }
  .mirror-table th,
  .mirror-table td {
    padding: 0.2rem;
    font-size: 0.8rem;
  }
}

</style>